export const ChangeIsRtl = (val) => {
    return ({
        type: 'SET_ISRTL',
        value: {
            val: val
        }
    })
}
export const SetLang = (val) => {
    return ({
        type: 'SET_LANG',
        value: {
            val: val
        }
    })
}
export const SetMode = (val) => {
    return ({
        type: 'SET_MODE',
        value: {
            val: val
        }
    })
}